import { toast } from 'react-toastify';
import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchAdminUser } from 'redux/actions/AdminUserAction';
import { GET_ADDADMINUSER, GET_ADMINUSER,GET_UPDATEADMINUSER} from 'resources/actionTypes';
import { getAdminUsers, addAdminUserApi,updateAdminUserApi } from 'services/AdminUserService';
import store from "redux/store";

function* getAdminUser(action) {
  const payload = action.payload || {}
  const adminUser = yield call(getAdminUsers,payload);

  if (adminUser.success) {
    yield put({
      type: GET_ADMINUSER.GET_ADMINUSER_SUCCESS,
      adminUser: adminUser?.data,
    });
  } else {
    yield put({
      type: GET_ADMINUSER.GET_ADMINUSER_FAILED,
      message: adminUser.message,
    });
    toast.error(
      adminUser?.message || 'Fetching roles and permissions failed'
    );
  }
}

export function* getAdminUserWatcher() {
  yield takeEvery(
    GET_ADMINUSER.GET_ADMINUSER_REQUESTED,
    getAdminUser
  );
}

function* fetchAddAdminUser(action) {
  const payload = action.payload || {}
  const userAddAdminUser = yield call(addAdminUserApi, payload.userAddAdminUser);
  if(userAddAdminUser.success){
    yield put({ type: GET_ADDADMINUSER.GET_ADDADMINUSER_SUCCESS, userAddAdminUser: userAddAdminUser });
    toast.success(userAddAdminUser.message);
    store.dispatch(fetchAdminUser());
  }else{
    yield put({ type: GET_ADDADMINUSER.GET_ADDADMINUSER_FAILED, message: userAddAdminUser.message });
    toast.error(userAddAdminUser?.message || 'Add User failed');
  }
}
export function* addAdminUserSaga() {
  yield takeEvery(GET_ADDADMINUSER.GET_ADDADMINUSER_REQUESTED, fetchAddAdminUser);

}

function* fetchUpdateAdminUser(action) {
  const payload = action.payload || {}
  const userUpdateAdminUser = yield call(updateAdminUserApi, payload.userUpdateAdminUser);
  if(userUpdateAdminUser.success){
    yield put({ type: GET_UPDATEADMINUSER.GET_UPDATEADMINUSER_SUCCESS, userUpdateAdminUser: userUpdateAdminUser });
    toast.success(userUpdateAdminUser.message);
    store.dispatch(fetchAdminUser());
  }else{
    yield put({ type: GET_UPDATEADMINUSER.GET_UPDATEADMINUSER_FAILED, message: userUpdateAdminUser.message });
    toast.error(userUpdateAdminUser?.message || 'Update Vendor failed');
  }
}
export function* updateAdminUserSaga() {
  yield takeEvery(GET_UPDATEADMINUSER.GET_UPDATEADMINUSER_REQUESTED, fetchUpdateAdminUser);

}